export interface Language {
  code: string;
  label: string;
  full: string;
}

export const languages: Language[] = [
  { code: 'en', label: 'EN', full: 'English' },
  { code: 'fr', label: 'FR', full: 'Français' },
  { code: 'da', label: 'DA', full: 'Dansk' },
  { code: 'de', label: 'DE', full: 'Deutsch' },
];

export const validLangs = ['en', 'fr', 'da', 'de'];

export function getCategoryName(cat: { nameEn: string; nameFr: string; nameDa: string; nameDe: string }, lang: string): string {
  switch (lang) {
    case 'fr': return cat.nameFr;
    case 'da': return cat.nameDa;
    case 'de': return cat.nameDe;
    default: return cat.nameEn;
  }
}